import React from 'react'

import {PageStoreInterface} from '@/src/ports/store/page-store'

export const StoreContext = React.createContext<PageStoreInterface | null>(null)
